<template>
  <v-card v-bind="$attrs" :class="MyClass">
    <v-col class="ma-0 pa-0 box-container" style="height: 100%">
      <t-btn
        v-if="editClick"
        size="small"
        style="justify-content: center; position: absolute; top: 5px; right: 5px; border-radius: 20px"
        icon=""
        @click="editClick(station)"
      >
        <v-icon size="24">mdi-pencil</v-icon>
      </t-btn>

      <v-tooltip :disabled="hideTooltips" location="top">
        <template v-slot:activator="{ props }">
          <v-card
            v-if="!station.fd || station.fd.displayFailedLastTry"
            v-bind="props"
            style="position: absolute; top: 5px; left: 5px; padding: 3px; border-radius: 15px"
            variant="outlined"
            icon=""
          >
            <v-icon size="30" color="error"> mdi-credit-card-off-outline</v-icon>
          </v-card>
        </template>
        <span style="white-space: pre-wrap">{{ station.fd ? "Няма връзка с разплащателния модул!" : "Липсва разплащателен модул!" }} </span>
      </v-tooltip>

      <v-tooltip :disabled="hideTooltips" location="top">
        <template v-slot:activator="{ props }">
          <v-card-title
            v-bind="props"
            :class="IF.MyFontTitle"
            class="ma-1 pa-0 align-center font-weight-medium"
            style="cursor: pointer"
            @click="if (imageClick) imageClick(station);"
          >
            <span>{{ station.name }}</span>
          </v-card-title>
        </template>
        <span style="white-space: pre-wrap">{{ station.id + "\nСтатус: " + MyClass + "\n\nУБ: " + (station.fd ? station.fd.sn : "") }} </span>
      </v-tooltip>
      <slot name="subtitle"></slot>
      <v-tooltip :disabled="hideTooltips" location="top">
        <template v-slot:activator="{ props }">
          <div v-bind="props" v-if="station.SumToday && IF.ShowSums && !editClick" style="position: absolute; right: 3px; top: 3px">
            <!-- <v-icon :size="20" :color="Colors.IconColor">mdi-cash-check</v-icon> -->
            <v-chip class="white--text" :class="IF.MyFont" variant="flat" :color="Colors.ActiveItemBackground">{{ station.SumToday.toFixed(2) }}</v-chip>
          </div>
        </template>
        <span v-if="station.SumToday && IF.ShowSums && !editClick">{{ "Натрупан оборот за деня: " + station.SumToday.toFixed(2) + " €" }}</span>
      </v-tooltip>
      <v-row class="ma-0 row-content" :class="IF.MyFont">
        <div style="width: 120px; align-content: center">
          <v-img
            v-if="!!station.Image"
            :src="station.Image"
            :lazy-src="defaultImage"
            contain
            :width="180"
            aspect-ratio="0.8"
            style="cursor: pointer"
            @click="if (imageClick) imageClick(s);"
          >
          </v-img>
          <span v-if="station.Price" style="font-size: 14px; white-space: pre-wrap">{{ station.Price.toFixed(2) + " €/KWh" }}</span>
        </div>
        <v-col class="ma-0 pa-0">
          <v-row class="ma-0 pa-0 fill-height" align="center">
            <v-tooltip v-if="station.Status == ChargeStationStatus.Offline" :disabled="hideTooltips" location="top">
              <template v-slot:activator="{ props }">
                <span v-bind="props">{{ "Офлайн от " + station.lastCPTalk.toTremolFpString() }}</span>
              </template>
              <span>{{ "Последно на линия преди " + calcOfflineMinutes(station.lastCPTalk) }}</span>
            </v-tooltip>
            <v-tabs direction="vertical" :hide-slider="true" :show-arrows="false" :fixed-tabs="true">
              <v-tab
                v-for="(conn, connname, index) in station.onlineConnectors"
                :key="index"
                class="ma-0 my-1 pa-0"
                :class="conn == connector ? 'ConnectorSelected' : ''"
                height="auto"
                :text="getConnectorText(conn)"
                :conn="index"
                @click="
                  if (connectorClick) connectorClick(conn);
                  index = index;
                "
              >
                <slot prepend>
                  <v-tooltip :disabled="hideTooltips || station.Status != ChargeStationStatus.Online" location="left">
                    <template v-slot:activator="{ props }">
                      <div v-bind="props" style="position: relative">
                        <v-icon :size="30" :color="conn.free ? 'yellow' : conn.IconColor">{{ conn.Icon }}</v-icon>
                        <!-- <v-icon v-if="conn.free" style="z-index: 99999; position: absolute; bottom: -10px; right: -10px" :size="20" color="red">mdi-cash-remove</v-icon> -->
                      </div>
                    </template>
                    <span v-if="conn.Type">{{ conn.Type + (conn.free ? " в безплатен режим!!!" : "") }}</span>
                  </v-tooltip>
                  <div :class="IF.MyFont" style="display: inline-block; white-space: pre-wrap; text-align: start">
                    <span style="white-space: pre-wrap; text-align: start">
                      {{ getConnectorText(conn) }}
                      <template v-if="conn.statusNotifReqStr == ChargeStationConnectorStatus.Charging">
                        <template v-if="conn.viewIdtagFromSartTrans">
                          <v-icon v-if="conn.viewIdtagFromSartTrans.vidAutoCharge" :size="20" color="green">mdi-car-electric-outline</v-icon>
                          <v-icon v-else-if="conn.viewIdtagFromSartTrans.type == 'CARD'" :size="20" color="green">mdi-card-account-details-outline</v-icon>
                          <v-icon v-else-if="conn.LastTransaction && conn.LastTransaction.preAuthAmount" :size="20" color="green"
                            >mdi-credit-card-check-outline</v-icon
                          >
                          <v-icon v-else :size="20" color="red">mdi-credit-card-off-outline</v-icon>
                        </template>
                        <template v-if="conn.chargeRateKW || conn.soC">
                          {{ "\n    " }}
                          <template v-if="conn.soC">
                            <v-icon :size="20" color="green">mdi-battery-charging</v-icon>
                            {{ conn.soC + "%" }}
                          </template>
                          <template v-if="conn.chargeRateKW">
                            <v-icon :size="20" color="green">mdi-flash</v-icon>
                            {{ conn.chargeRateKW.toFixed(3) }}
                          </template>
                        </template>

                        <!-- <template v-if="conn._MaxchargeRateKW">
                              {{ " (" }}<v-icon :size="20" color="red">mdi-flash</v-icon>
                              {{ conn._MaxchargeRateKW.toFixed(3) + ")" }}
                            </template> -->

                        <!-- <span>{{ "\n    " + conn.StateOfCharge }}</span> -->
                        <!-- <template v-if="conn._MaxchargeRateKW">
                              <span style="color: red">{{ "\n    🗲 (max) " + conn._MaxchargeRateKW.toFixed(3) }}</span>
                            </template> -->
                        <!-- chargeTagCevUser -->
                        <template
                          v-if="
                            conn.StateOfCharge &&
                            conn.viewIdtagFromSartTrans &&
                            conn.viewIdtagFromSartTrans.type &&
                            conn.viewIdtagFromSartTrans.tagName &&
                            !conn.viewIdtagFromSartTrans.tagName.toLowerCase().startsWith('ac') &&
                            !conn.viewIdtagFromSartTrans.type.toLowerCase().contains('default')
                          "
                        >
                          {{ "\n      " + conn.viewIdtagFromSartTrans.tagName }}

                          <!-- <template v-else>{{ "Липсва преавторизация." }}</template> -->
                        </template>
                      </template>
                    </span>
                    <span
                      v-if="
                        station.Status == ChargeStationStatus.Online &&
                        conn.statusNotifReqStr == ChargeStationConnectorStatus.Finishing &&
                        conn.LastTransaction &&
                        conn.LastTransaction.stopTime &&
                        calcOfflineMinutes(conn.LastTransaction.stopTime)
                      "
                    >
                      {{ "\n      преди " + calcOfflineMinutes(conn.LastTransaction.stopTime) }}
                    </span>
                  </div>
                </slot>
              </v-tab>
            </v-tabs>
          </v-row>
        </v-col>
      </v-row>
      <slot name="bottom"> </slot>
    </v-col>
  </v-card>
</template>

<script>
import ChargeStationConnectorStatus from "@/js/ChargeStationConnectorStatus";
import ChargeStationStatus, { getString } from "@/js/ChargeStationStatus";

const mp3 = require("@/assets/audio/warning.mp3");

export default {
  props: {
    showPrice: {
      default: false,
    },
    station: null,
    imageClick: null,
    editClick: null,
    connector: null,
    connectorClick: null,
  },
  data() {
    return {
      defaultImage: `${process.env.BASE_URL}images/DEFAULT.png`,
      tabs: [],
      index: -1,
      conn: this.connector,
      ChargeStationConnectorStatus: ChargeStationConnectorStatus,
      ChargeStationStatus: ChargeStationStatus,
    };
  },
  computed: {
    MyClass() {
      return getString(this.station.Status);
    },
  },
  methods: {
    getConnectorText(cnn) {
      var txt = cnn.lastFDDisplayStatus;
      if (this.showPrice) {
        if (cnn.free) {
          txt = "Безплатен режим!\n" + txt;
        } else {
          txt = cnn.price_per_kwh.toFixed(2) + " €/KWh \n" + txt;
        }
      }
      return txt;
    },
    calcOfflineMinutes(dateForDiff) {
      var diffMs = new Date() - dateForDiff;
      var mins = Math.round(diffMs / 60000);
      var m = mins % 60;
      var h = (mins - m) / 60;
      if (h > 0) {
        return h + " ч. " + m + " мин.";
      }
      return m + " мин.";
    },
  },
  watch: {
    "station.fd": {
      handler(val, old_val) {
        if (val && old_val && val.sn == "ZK899901") {
          if (old_val.displayFailedLastTry == false && val.displayFailedLastTry == true) {
            new Audio(mp3).play();
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {},
};
</script>

<style>
</style>